import { render, staticRenderFns } from "./PatientSearchInput.vue?vue&type=template&id=21589748&scoped=true&"
import script from "./PatientSearchInput.vue?vue&type=script&lang=js&"
export * from "./PatientSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./PatientSearchInput.vue?vue&type=style&index=0&id=21589748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21589748",
  null
  
)

export default component.exports